export const UiBreadcrumbs = class {
  constructor() {
    this.block = document.querySelector('.ui-breadcrumbs')

    if (!this.block) {
      throw new Error('[UiBreadcrumbs]: Breadcrumbs block is not defined')
    }

    this.sliderList = this.block.querySelector('.ui-breadcrumbs-list')

    this.setIsNeedScroll()
    window.addEventListener('resize', this.setIsNeedScroll)
    this.sliderList.addEventListener('scroll', this.breadcrumbsScrollHandler)
  }

  setIsNeedScroll = () => {
    const breadcrumbsWrapperWidth = this.sliderList.clientWidth
    const contentWidth = this.sliderList.scrollWidth

    if (contentWidth > breadcrumbsWrapperWidth) {
      this.sliderList.scrollLeft = contentWidth
    }
  }

  breadcrumbsScrollHandler = (evt) => {
    const breadcrumbsWrapper = evt.target
    const isEnd = Math.round(breadcrumbsWrapper.clientWidth + breadcrumbsWrapper.scrollLeft) >= breadcrumbsWrapper.scrollWidth

    const isNotFirstSlide = breadcrumbsWrapper.scrollLeft
    const isNotLastSlide = !isEnd

    this.block.classList.toggle('ui-breadcrumbs--gradient-left', isNotFirstSlide)
    this.block.classList.toggle('ui-breadcrumbs--gradient-right', isNotLastSlide)
  }
}
